import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Data } from '@angular/router';
// import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
// import { Label } from 'ng2-charts';
import { DataService } from 'src/app/Common/data.service';
import { Chart as ChartJS, LinearScale, CategoryScale, BarElement, Title, Tooltip, Legend, BarController } from 'chart.js';

@Component({
  selector: 'app-admin-bar-chart',
  templateUrl: './admin-bar-chart.component.html',
  styleUrls: ['./admin-bar-chart.component.scss'],
  providers: [DataService]
})
export class AdminBarChartComponent implements OnInit {
    AdminBarChartForm: UntypedFormGroup;
  chart: any;  // Variable to hold the chart instance
  viewdata: any;  // Variable to hold dynamic data

  constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder) { }

  ngOnInit() {
    // Register the necessary components for chart.js v4
    ChartJS.register(
      BarController,    // Register BarController for the bar chart type
      LinearScale,      // Register LinearScale for y-axis
      CategoryScale,    // Register CategoryScale for x-axis
      BarElement,       // Register BarElement for bar charts
      Title,            // Register Title component
      Tooltip,          // Register Tooltip component
      Legend            // Register Legend component
    );

    this.AdminBarChartForm = this._fb.group({
      spmode: ['']
    });
    this.getdata();
  }

  // Method to fetch data from the backend and create the chart
  getdata() {
    this.AdminBarChartForm.patchValue({
      spmode: 1,
    });
    this._dataservice.PostData('Category/GetBarChart/', this.AdminBarChartForm.value).subscribe(result => {
      console.log('result1', result);
      this.viewdata = result;
      this.createChart();  // Call createChart() to render the chart once data is fetched
    });
  }

  // Method to create a bar chart using Chart.js
  createChart() {
    const barChartData = {
      labels: ['High', 'Medium', 'Low'], // Labels for the bars (can be dynamic if necessary)
      datasets: [{
        label: 'Service Requests',
        data: this.viewdata,  // Data fetched from the service
        backgroundColor: 'rgba(75, 192, 192, 0.2)', // Bar color
        borderColor: 'rgba(75, 192, 192, 1)',  // Border color
        borderWidth: 1  // Border width
      }]
    };

    const chartOptions = {
      responsive: true,
      scales: {
        y: {
          beginAtZero: true  // Start y-axis from 0
        }
      }
    };

    // Create the chart with the ID 'myChart'
    this.chart = new ChartJS('myChart', {
      type: 'bar',  // Bar chart
      data: barChartData,
      options: chartOptions
    });
  }
}
//   AdminBarChartForm: UntypedFormGroup;
//   constructor(public _dataservice: DataService, private _fb: UntypedFormBuilder) { }

//   public barChartOptions: ChartOptions = {
//     responsive: true,
//     scales: {
//       x: {
//         grid: {
//           display: true,  // Enable vertical lines on the x-axis
//         },
//       },
//       y: {
//         grid: {
//           display: true,  // Enable vertical lines on the y-axis
//         },
//       },
//     },
//   };
//   public barChartLabels = ['High', 'Medium', 'Low'];
//   public barChartType: ChartType = 'bar';
//   public barChartLegend = true;
//   // public barChartData = [{ data: [], label: '' }];
//   public barChartData = [
//     { data: [65, 59, 80], label: 'Dataset 1' },
//     { data: [28, 48, 40], label: 'Dataset 2' }
//   ];
//   barchart = [];
//   viewdata: any;
//   ngOnInit() {
//     this.AdminBarChartForm = this._fb.group({
//       spmode: ['']
//     });
//     // this.getdata();
//   }

//   getdata() {
//     this.AdminBarChartForm.patchValue({
//       spmode: 1,
//     });
//     this._dataservice.PostData('Category/GetBarChart/', this.AdminBarChartForm.value).subscribe(result => {
//       this.viewdata = result;
//       this.barChartData = this.viewdata;
//     });
//   }
// }